import { userEndpoints } from '../../services/api/endpoints/user.endpoint';
import { ChatUser, RequestNewUserData } from '../../types/user';

export const createRequstedUser = async (orgId: string, userData: RequestNewUserData) => {
  await userEndpoints.createRequestedUser(orgId, userData);
};

// Export a constant function called OrgLongPolling that takes in a string parameter called orgId and returns a Promise of a boolean
export const requestedUserLongPolling = async (orgId: string, uuid: string): Promise<boolean> => {
  // Return a new Promise
  return new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      try {
        const statusResponse: ChatUser[] = await userEndpoints.getChatUserByUuid(orgId, uuid);
        const orgStatus = statusResponse[0]?.status;
        if (orgStatus === 'active') {
          clearInterval(interval);
          resolve(true);
        }
        if (orgStatus !== 'pending') {
          clearInterval(interval);
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    }, 10000);
  });
};
